<div id="container">
    <img src="../../../assets/back_arrow.png" alt="" width="18px" height="15px" id="icon" routerLink="/notes">
    <div id="title">{{title}}</div>
    <div id="context">...</div>
</div>